/**
 * Where each staged card is allowed to draw.
 *
 * A staged card can be REWRITTEN in place — "add another line to that email"
 * updates the row that is waiting instead of queueing a second one (see
 * `stageIdentity` in stage-action.ts). Server-side that is already safe: one
 * row, one send. But the same id then arrives attached to two different
 * assistant messages, and the older one is holding the SUPERSEDED wording — a
 * card an owner would read and tap, showing a draft that no longer exists.
 *
 * So a given id renders only where it was LAST seen. Shared rather than
 * computed twice: the panel and the bar now both draw these, and two surfaces
 * disagreeing about which copy is live is the same fault with a second face.
 */
export function latestStagedIndex(
  messages: readonly { stagedActions?: readonly { id: string }[] }[],
): Map<string, number> {
  const at = new Map<string, number>();
  messages.forEach((m, i) => m.stagedActions?.forEach(sa => at.set(sa.id, i)));
  return at;
}
